import React, { Component } from "react";
import MainLayout from '../mainLayout';

// Images import
import serachIcon from "../assets/images/search.svg";
import edit from "../assets/images/edit.svg";
import lock from "../assets/images/lock.svg";
import delet from "../assets/images/delet.svg";
import share from "../assets/images/share.svg";
import hoverIcon from "../assets/images/hover-popup.svg";
import close from "../assets/images/close.svg";
import cloud from "../assets/images/cloud.svg";
import plusIcon from "../assets/images/plusIcon.svg";
import background from "../assets/images/background.jpg";


class ArtistsView extends Component {
    render() {
        return (
            <React.Fragment>
                    <div className="right_side_wrapper artistView_wrapper">
                        <div className="dashboard_header with_btn">
                            <div className="searchBlock">
                                <span>Artists (25)</span>
                                <form>
                                    <input type="text" placeholder="Search" />
                                    <button type="submit">
                                        <img src={serachIcon} />
                                    </button>
                                </form>
                            </div>
                            <div className="button_block admin_user_twoBtn">
                                <div className="icon_block">
                                    <a href=""><img src={cloud} /></a>
                                </div>
                                <a href="" className="head_btn">Add Artist</a>
                            </div>
                        </div>
                        <div className="dashboard_data">
                            <table>
                                <thead>
                                    <tr>
                                        <th className="firstName_d">First Name</th>
                                        <th className="lastName_d">Last Name</th>
                                        <th className="email_d">Email</th>
                                        <th className="regOn_d">Last Logged On</th>
                                        <th className="addOn_d">Added On</th>
                                        <th className="icon_d"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="firstName_d">Peter</td>
                                        <td className="lastName_d">Sanchez</td>
                                        <td className="email_d">christine_conell@sundance.org</td>
                                        <td className="regOn_d">07/12/2020</td>
                                        <td className="addOn_d">06/12/2020</td>
                                        <td className="icon_d">
                                            <a href=""><img src={edit} /><div>edit</div></a>
                                            <a href=""><img src={lock} /><div>lock</div></a>
                                            <a href=""><img src={delet} /><div>delet</div></a>
                                            <a href="">
                                                {/* <img src={share} /><div>share</div> */}
                                                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.33203 8.66668L9.66536 6.00001L6.33203 3.33334V5.33334H0.332031V6.66668H6.33203V8.66668Z" fill="#5D737E"/>
                                                    <path d="M7.66601 -0.000678997C6.87769 -0.00286479 6.09678 0.151395 5.3685 0.453163C4.64023 0.754932 3.97908 1.19821 3.42334 1.75732L4.36601 2.69999C5.24734 1.81865 6.41934 1.33265 7.66601 1.33265C8.91267 1.33265 10.0847 1.81865 10.966 2.69999C11.8473 3.58132 12.3333 4.75332 12.3333 5.99999C12.3333 7.24665 11.8473 8.41866 10.966 9.29999C10.0847 10.1813 8.91267 10.6673 7.66601 10.6673C6.41934 10.6673 5.24734 10.1813 4.36601 9.29999L3.42334 10.2427C4.55601 11.376 6.06267 12.0007 7.66601 12.0007C9.26934 12.0007 10.776 11.376 11.9087 10.2427C13.042 9.10999 13.6667 7.60332 13.6667 5.99999C13.6667 4.39665 13.042 2.88999 11.9087 1.75732C11.3529 1.19821 10.6918 0.754932 9.96351 0.453163C9.23524 0.151395 8.45432 -0.00286479 7.66601 -0.000678997Z" fill="#5D737E"/>
                                                </svg>
                                                {/* <div>share</div> */}
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="firstName_d">Peter</td>
                                        <td className="lastName_d">Sanchez</td>
                                        <td className="email_d">christine_conell@sundance.org</td>
                                        <td className="regOn_d">07/12/2020</td>
                                        <td className="addOn_d">06/12/2020</td>
                                        <td className="icon_d">
                                            <a href=""><img src={edit} /><div>edit</div></a>
                                            <a href=""><img src={lock} /><div>lock</div></a>
                                            <a href=""><img src={delet} /><div>delet</div></a> 
                                            <a href="">
                                                {/* <img src={share} /><div>share</div> */}
                                                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.33203 8.66668L9.66536 6.00001L6.33203 3.33334V5.33334H0.332031V6.66668H6.33203V8.66668Z" fill="#5D737E"/>
                                                    <path d="M7.66601 -0.000678997C6.87769 -0.00286479 6.09678 0.151395 5.3685 0.453163C4.64023 0.754932 3.97908 1.19821 3.42334 1.75732L4.36601 2.69999C5.24734 1.81865 6.41934 1.33265 7.66601 1.33265C8.91267 1.33265 10.0847 1.81865 10.966 2.69999C11.8473 3.58132 12.3333 4.75332 12.3333 5.99999C12.3333 7.24665 11.8473 8.41866 10.966 9.29999C10.0847 10.1813 8.91267 10.6673 7.66601 10.6673C6.41934 10.6673 5.24734 10.1813 4.36601 9.29999L3.42334 10.2427C4.55601 11.376 6.06267 12.0007 7.66601 12.0007C9.26934 12.0007 10.776 11.376 11.9087 10.2427C13.042 9.10999 13.6667 7.60332 13.6667 5.99999C13.6667 4.39665 13.042 2.88999 11.9087 1.75732C11.3529 1.19821 10.6918 0.754932 9.96351 0.453163C9.23524 0.151395 8.45432 -0.00286479 7.66601 -0.000678997Z" fill="#5D737E"/>
                                                </svg>
                                                {/* <div>share</div> */}
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="firstName_d">Peter</td>
                                        <td className="lastName_d">Sanchez</td>
                                        <td className="email_d">christine_conell@sundance.org</td>
                                        <td className="regOn_d">07/12/2020</td>
                                        <td className="addOn_d">06/12/2020</td>
                                        <td className="icon_d">
                                            <a href=""><img src={edit} /><div>edit</div></a>
                                            <a href=""><img src={lock} /><div>lock</div></a>
                                            <a href=""><img src={delet} /><div>delet</div></a>
                                            <a href="">
                                                {/* <img src={share} /><div>share</div> */}
                                                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.33203 8.66668L9.66536 6.00001L6.33203 3.33334V5.33334H0.332031V6.66668H6.33203V8.66668Z" fill="#5D737E"/>
                                                    <path d="M7.66601 -0.000678997C6.87769 -0.00286479 6.09678 0.151395 5.3685 0.453163C4.64023 0.754932 3.97908 1.19821 3.42334 1.75732L4.36601 2.69999C5.24734 1.81865 6.41934 1.33265 7.66601 1.33265C8.91267 1.33265 10.0847 1.81865 10.966 2.69999C11.8473 3.58132 12.3333 4.75332 12.3333 5.99999C12.3333 7.24665 11.8473 8.41866 10.966 9.29999C10.0847 10.1813 8.91267 10.6673 7.66601 10.6673C6.41934 10.6673 5.24734 10.1813 4.36601 9.29999L3.42334 10.2427C4.55601 11.376 6.06267 12.0007 7.66601 12.0007C9.26934 12.0007 10.776 11.376 11.9087 10.2427C13.042 9.10999 13.6667 7.60332 13.6667 5.99999C13.6667 4.39665 13.042 2.88999 11.9087 1.75732C11.3529 1.19821 10.6918 0.754932 9.96351 0.453163C9.23524 0.151395 8.45432 -0.00286479 7.66601 -0.000678997Z" fill="#5D737E"/>
                                                </svg>
                                                {/* <div>share</div> */}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>                    
                        <div className="popup_wrapper">
                        {/* style={{display: "none"}} */}
                            <h2>
                                Create New Artist
                                <img src={close} />
                            </h2>
                            <form>
                                <div className="details">                               
                                    <div>
                                        <label>Email</label>
                                        <input type="text" />
                                    </div>
                                    <div>
                                        <label>First Name</label>
                                        <input type="text" />
                                    </div>
                                    <div>
                                        <label>Last Name</label>
                                        <input type="text" />
                                    </div>
                                </div>
                                <div className="btn_wrapper">
                                    <button className="grayBTN">Clear</button>
                                    <button className="orangeBTN" type="submit">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
            </React.Fragment> 
        )
    }
}
export default ArtistsView;
